import type { FeatureFlagName } from '@/types';
import Cookies from 'universal-cookie';

const HEV_USER_COOKIE = 'hev-user-cookie';
const COOKIE_EXPIRATION_DAYS = 60 * 60 * 24 * 30; // 30 days in seconds

const cookies = new Cookies();

export function getHevUserCookie() {
  return cookies.get(HEV_USER_COOKIE);
}

export function setHevUserCookie() {
  return cookies.set(HEV_USER_COOKIE, 1, {
    path: '/', // Makes it available to /en/insertion AND /en/my-ads
    expires: new Date(Date.now() + COOKIE_EXPIRATION_DAYS * 1000),
  });
}

/** Expiry and domain for experiment / split-treatment cookies (feature flags store). */
export interface FeatureFlagCookieScope {
  expires: Date;
  domain: string | undefined;
  path: '/';
}

export function getFeatureFlagCookieScope(): FeatureFlagCookieScope {
  const expires = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  const domain = import.meta.env.VUE_APP_BASE_URL?.split('//')[1];
  return { expires, domain, path: '/' };
}

/** Cookie API shape used by `@vueuse/integrations/useCookies`. */
export interface FeatureFlagCookieClient {
  set?: (
    name: string,
    value: string,
    options: { expires: Date; domain?: string; path: string },
  ) => void;
  remove?: (name: string, options: { domain?: string; path: string }) => void;
}

/**
 * Persists a split-treatment value or clears the cookie when the API returns no treatment.
 */
export function setOrRemoveFeatureFlagCookie(
  cookies: FeatureFlagCookieClient | undefined,
  scope: FeatureFlagCookieScope,
  flagName: FeatureFlagName,
  treatment: string | undefined,
): void {
  if (treatment) {
    cookies?.set?.(flagName, treatment, {
      expires: scope.expires,
      domain: scope.domain,
      path: scope.path,
    });
  } else {
    cookies?.remove?.(flagName, { domain: scope.domain, path: scope.path });
  }
}
